export default __webpack_public_path__ + "static/media/accommodation5.0515df43.webp";